import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

import { DetailsRow } from '@sh4res/bo-common/components/B2bEmployeeBulkCreate/components/DetailsRow';

interface DetailsRowGridProps {
  action: 'error' | 'update';
  rawData: Record<string, string | null>[];
  shouldRenderRow: (idx: number) => boolean;
  rowNumberForIndex: (idx: number) => number;
  info: (idx: number) => Record<string, string | number | null> | null;
  infoIgnored?: (idx: number) => Record<string, string | number | null> | null | undefined;
  highlightRowClassName: string;
  highlightCellClassName: string;
  columnMapping?: Record<string, string>;
  sx?: SxProps<Theme>;
}

export function DetailsRowGrid(props: DetailsRowGridProps) {
  return (
    <Box
      sx={{
        border: '1px solid grey',
        borderRadius: 1,
        fontFamily: 'Monospace',
        display: 'grid',
        gridTemplateColumns: 'min-content auto',
        ...props.sx,
      }}>
      {props.rawData.reduce((agg: ReactNode[], row, idx) => {
        if (props.shouldRenderRow(idx)) {
          agg.push(
            <DetailsRow
              key={idx}
              action={props.action}
              row={row}
              rowNumber={props.rowNumberForIndex(idx)}
              info={props.info(idx)}
              infoIgnored={props.infoIgnored?.(idx)}
              highlightRowClassName={props.highlightRowClassName}
              highlightCellClassName={props.highlightCellClassName}
              columnMapping={props.columnMapping}
            />,
          );
        }
        return agg;
      }, [])}
    </Box>
  );
}
